// components/ScrollToTop.jsx
import { useEffect } from 'react';
import { useRouter } from 'next/router';

function ScrollToTop() {
  const router = useRouter();

  useEffect(() => {
    // 定义滚动到顶部的函数 - 直接跳转，无动画
    const handleRouteChangeComplete = () => {
      // 强制立即滚动到顶部，无动画效果
      if (typeof window !== 'undefined') {
        // 对于移动端，同时处理 body 和 window 的滚动
        document.body.scrollTop = 0; // Safari 移动端
        document.documentElement.scrollTop = 0; // 其他浏览器
        window.scrollTo(0, 0); // 兜底方案
      }
    };

    // 订阅多个路由事件，确保覆盖所有场景
    router.events.on('routeChangeComplete', handleRouteChangeComplete);

    // 组件卸载时取消订阅，防止内存泄漏
    return () => {
      router.events.off('routeChangeComplete', handleRouteChangeComplete);
    };
  }, [router.events]); // 依赖 router.events，确保在 router 变化时重新注册事件

  return null; // 这个组件不渲染任何 UI，只用于副作用
}

export default ScrollToTop;